// 嘿料吃瓜 首页 mock 数据（静态展示用，后续可接真实档案库）

export const quickFeed = [
  {
    time: "09:42",
    date: "今天",
    tag: "突发热搜",
    title: "综艺收官夜又出大瓜：导师情绪失控提前离场，弹幕直接炸了",
    excerpt: "直播刚进尾声，某常驻导师被镜头拍到黑脸摔台本离场，节目组紧急切广告救场，瓜田瞬间沸腾。",
    image: "https://readdy.ai/api/search-image?query=noisy%20backstage%20of%20a%20variety%20show%20with%20camera%20lights%20and%20crew%20bustling%2C%20warm%20amber%20dramatic%20spotlight%2C%20cinematic%20editorial%20photography%20in%20rich%20terracotta%20and%20cream%20tones%2C%20high%20detail%2C%20magazine%20reportage%20style&width=720&height=480&seq=qf-feat-01&orientation=landscape",
    hot: 98,
  },
  {
    time: "08:15",
    date: "今天",
    tag: "剧集",
    title: "《雾里藏星》双男主戏外互动被逐帧解读，导演直播回应话里有话",
    excerpt: "预告片里一帧对视被嗑学家长文拆解，编剧隔空喊话：留白是给观众的礼物。",
    hot: 87,
  },
  {
    time: "昨夜 23:08",
    date: "昨天",
    tag: "饭圈",
    title: "后援会深夜连发三条公告，解散传闻冲上话题前排",
    excerpt: "一次应援明细的争议发酵成组织危机，核心大粉集体卸任，评论区吵成两派。",
    hot: 76,
  },
  {
    time: "昨夜 21:30",
    date: "昨天",
    tag: "社媒翻车",
    title: "某主播念错品牌历史被当场纠正，涨粉几万的宠粉文案秒变翻车现场",
    excerpt: "本想卖情怀，结果被网友考古出旧帖，一条道歉动态点赞反而破百万。",
    hot: 69,
  },
  {
    time: "19:02",
    date: "昨天",
    tag: "音乐",
    title: "新歌上线前泄出 demo，制作人发长文：尊重创作，也别急着定罪",
    excerpt: "三段未定稿音频在深夜流传，粉丝与路人各执一词，数据榜却悄悄刷新纪录。",
    hot: 61,
  },
];

export const hotRanking = [
  { rank: 1, title: "全员塌房式综艺：同一档节目连挂三天热搜，节目组道歉三次", count: 1286, delta: "+31万" },
  { rank: 2, title: "一年翻红两次的选秀回锅王，这次又被考古出老视频", count: 1042, delta: "+24万" },
  { rank: 3, title: "直播间「家人」话术翻车实录，看完我脚趾扣出三室一厅", count: 932, delta: "+19万" },
  { rank: 4, title: "被爆改合同条款的顶流男星，合同金额前后版本差了近三倍", count: 815, delta: "+16万" },
  { rank: 5, title: "国民级 IP 续作导演被全网讨伐：改编还是魔改？", count: 703, delta: "+12万" },
  { rank: 6, title: "一场颁奖礼的座位表，成了比正片还精彩的大戏", count: 598, delta: "+9万" },
  { rank: 7, title: "隐婚三年被拍到同框，经纪人一句「尊重隐私」引爆评论区", count: 467, delta: "+7万" },
  { rank: 8, title: "大热恋综刚收官，官配 CP 线下避嫌现场被全程直播", count: 388, delta: "+5万" },
];

export const eventArchive = [
  {
    date: "2026.09",
    tag: "正在发酵",
    title: "一场延期两月的发布会，为何成了网友口中的「年度大戏」",
    synopsis:
      "从官宣到改期再到空降，主办方每一步都被逐条拆解。真相复盘会我们把所有时间线摊开，看看舆论究竟被哪只手轻轻推了一下。",
    steps: ["官宣定档", "临场改期", "空降炸场", "全网复盘"],
    image: "https://readdy.ai/api/search-image?query=elegant%20press%20conference%20stage%20with%20warm%20spotlight%20and%20empty%20red%20velvet%20chairs%20in%20shadow%2C%20cinematic%20editorial%20photography%2C%20moody%20terracotta%20and%20cream%20palette%2C%20soft%20directional%20light%2C%20high%20detail%20magazine%20reportage%20feel&width=960&height=600&seq=ev-a1&orientation=landscape",
    reads: "3.2万",
  },
  {
    date: "2026.08",
    tag: "已复盘",
    title: "「考古即塌房」：一句旧综艺里的玩笑话，凭什么炸了热搜",
    synopsis:
      "五年前的镜头被翻出，字里行间被逐帧重新造句。我们想聊的，是吃瓜上头时，怎么给一次「翻旧账」留一点讨论的余地。",
    steps: ["旧片翻红", "片段疯传", "当事人回应", "舆论转向"],
    image: "https://readdy.ai/api/search-image?query=vintage%20television%20studio%20with%20old%20cameras%20and%20film%20reels%20in%20warm%20dusty%20light%2C%20nostalgic%20editorial%20photography%2C%20cream%20and%20umber%20tones%2C%20soft%20shadows%2C%20cinematic%20composition%2C%20magazine%20archive%20aesthetic&width=960&height=600&seq=ev-a2&orientation=landscape",
    reads: "2.7万",
  },
  {
    date: "2026.07",
    tag: "追踪中",
    title: "品牌代言人一朝翻车，连夜解约背后的「违约金」经济学",
    synopsis:
      "名单一夜间被全部换下，连周边都紧急下架。我们把解约公告按时间排出，再看品牌方的公关手法，到底藏了多少层话术。",
    steps: ["热搜引爆", "品牌观望", "集体解约", "暗流涌动"],
    image: "https://readdy.ai/api/search-image?query=luxury%20brand%20billboard%20being%20taken%20down%20at%20dusk%20by%20workers%20on%20a%20lift%2C%20warm%20orange%20sky%20and%20soft%20editorial%20lighting%2C%20cinematic%20reportage%20photography%2C%20terracotta%20and%20cream%20moody%20palette%2C%20high%20detail&width=960&height=600&seq=ev-a3&orientation=landscape",
    reads: "2.4万",
  },
  {
    date: "2026.06",
    tag: "系列",
    title: "恋综售后观察：官配背后的营业团队，到底在忙什么",
    synopsis:
      "从显微镜嗑糖到避嫌辟谣，一对 CP 的售后周期被拆成四段。这是本月份「营业话术学」的第三期，也是嗑学家的必修课。",
    steps: ["高甜同框", "营业铺路", "暗藏伏笔", "售后收网"],
    image: "https://readdy.ai/api/search-image?query=romantic%20datingshow%20set%20decorated%20with%20warm%20string%20lights%20and%20blurred%20bokeh%20of%20pink%20roses%20in%20background%2C%20editorial%20photography%2C%20soft%20golden%20light%2C%20cream%20and%20coral%20tones%2C%20cinematic%20shallow%20depth%2C%20magazine%20feel&width=960&height=600&seq=ev-a4&orientation=landscape",
    reads: "2.1万",
  },
];

export const collections = [
  {
    title: "人物塌房档案",
    subtitle: "从神坛到谷底的全过程",
    count: 46,
    accent: "档案",
    image: "https://readdy.ai/api/search-image?query=tall%20stack%20of%20old%20newspapers%20and%20paper%20files%20with%20warm%20amber%20lamplight%2C%20moody%20editorial%20still%20life%20photography%2C%20terracotta%20and%20cream%20palette%2C%20soft%20shadows%2C%20magazine%20archive%20cover%20aesthetic%2C%20high%20detail&width=720&height=900&seq=col-01&orientation=portrait",
  },
  {
    title: "综艺名场面",
    subtitle: "名场面背后的八百个心眼",
    count: 38,
    accent: "名场面",
    image: "https://readdy.ai/api/search-image?query=colorful%20theater%20spotlight%20on%20empty%20stage%20with%20confetti%20floating%20in%20warm%20light%2C%20editorial%20photography%2C%20amber%20and%20cream%20palette%2C%20dramatic%20cinematic%20composition%2C%20magazine%20cover%20vibe%2C%20high%20detail&width=720&height=900&seq=col-02&orientation=portrait",
  },
  {
    title: "饭圈考古现场",
    subtitle: "显微镜下逐帧解读",
    count: 31,
    accent: "考古",
    image: "https://readdy.ai/api/search-image?query=hands%20holding%20magnifying%20glass%20over%20vintage%20photograph%20prints%20on%20warm%20desk%2C%20editorial%20photography%2C%20amber%20lamplight%2C%20cream%20and%20umber%20tones%2C%20cinematic%20closeup%2C%20magazine%20archival%20aesthetic&width=720&height=900&seq=col-03&orientation=portrait",
  },
  {
    title: "社媒翻车合集",
    subtitle: "每一句都值得复盘",
    count: 27,
    accent: "翻车",
    image: "https://readdy.ai/api/search-image?query=smartphone%20screen%20with%20cracked%20glass%20reflecting%20warm%20light%20on%20cream%20surface%2C%20editorial%20photography%2C%20terracotta%20and%20sand%20tones%2C%20soft%20shadows%2C%20cinematic%20moody%20composition%2C%20magazine%20style&width=720&height=900&seq=col-04&orientation=portrait",
  },
  {
    title: "真相复盘会",
    subtitle: "让子弹飞一会儿再说话",
    count: 19,
    accent: "复盘",
    image: "https://readdy.ai/api/search-image?query=round%20discussion%20table%20with%20coffee%20cups%20and%20open%20notebooks%20under%20warm%20overhead%20light%2C%20editorial%20photography%2C%20cream%20and%20amber%20palette%2C%20cinematic%20composition%2C%20thoughtful%20magazine%20mood%2C%20high%20detail&width=720&height=900&seq=col-05&orientation=portrait",
  },
  {
    title: "年度盘点大会",
    subtitle: "一整年的瓜一次看够",
    count: 52,
    accent: "年度",
    image: "https://readdy.ai/api/search-image?query=large%20annual%20report%20cover%20with%20gold%20foil%20typography%20on%20thick%20cream%20paper%20with%20red%20tassel%20bookmark%2C%20editorial%20flat%20lay%20photography%2C%20warm%20directional%20light%2C%20magazine%20cover%20aesthetic%2C%20high%20detail&width=720&height=900&seq=col-06&orientation=portrait",
  },
];

export const persons = [
  {
    role: "顶流男星 · 合约争议",
    name: "某顶流 · 合同风波主角",
    line: "一年两次登上「黑料合集」榜首，公关团队一年换了三拨。",
    files: 34,
    onList: 9,
    image: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20stylish%20male%20performer%20in%20shadow%20silhouette%20facing%20away%20from%20camera%2C%20warm%20terracotta%20and%20cream%20tones%2C%20soft%20directional%20studio%20light%2C%20cinematic%20magazine%20photography%2C%20high%20detail&width=600&height=600&seq=per-01&orientation=squarish",
  },
  {
    role: "选秀 · 回锅选手",
    name: "选秀回锅王",
    line: "翻红与翻车只隔一个热搜，旧视频永远是他的软肋。",
    files: 22,
    onList: 6,
    image: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20young%20male%20idol%20holding%20microphone%20backstage%20with%20warm%20amber%20lighting%2C%20cream%20and%20umber%20palette%2C%20soft%20shadows%2C%20cinematic%20magazine%20photography%2C%20high%20detail&width=600&height=600&seq=per-02&orientation=squarish",
  },
  {
    role: "演员 · 争议新花旦",
    name: "话题新晋花旦",
    line: "演技与通稿齐飞，红毯翻车与高光时刻同样出圈。",
    files: 18,
    onList: 5,
    image: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20glamorous%20female%20actress%20with%20warm%20golden%20key%20light%20and%20cream%20background%2C%20terracotta%20and%20sand%20tones%2C%20soft%20cinematic%20lighting%2C%20high%20fashion%20magazine%20photography%2C%20high%20detail&width=600&height=600&seq=per-03&orientation=squarish",
  },
  {
    role: "男团 · 塌房主唱",
    name: "塌房男团主唱",
    line: "一夜之间被扒出三年旧料，粉丝塌房现场比剧还精彩。",
    files: 15,
    onList: 4,
    image: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20male%20vocalist%20in%20dark%20studio%20with%20single%20warm%20spotlight%2C%20crimson%20and%20cream%20moody%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20cinematic%20magazine%20photography%2C%20high%20detail&width=600&height=600&seq=per-04&orientation=squarish",
  },
  {
    role: "网红 · 转型主播",
    name: "直播转型翻车咖",
    line: "从颜值博主到带货一姐的野心，被一句口误打回原形。",
    files: 12,
    onList: 3,
    image: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20influencer%20hosting%20live%20with%20ring%20light%20glow%2C%20warm%20cream%20and%20amber%20tones%2C%20soft%20cinematic%20lighting%2C%20terracotta%20accents%2C%20high%20detail%20magazine%20photography&width=600&height=600&seq=per-05&orientation=squarish",
  },
  {
    role: "幕后 · 神秘导演",
    name: "神秘新人导演",
    line: "作品封神与绯闻缠身并存，采访里全是绕开的话题。",
    files: 9,
    onList: 2,
    image: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20filmmaker%20holding%20clapperboard%20in%20warm%20theater%20light%20silhouette%2C%20cream%20and%20umber%20palette%2C%20soft%20shadows%2C%20cinematic%20magazine%20photography%2C%20high%20detail&width=600&height=600&seq=per-06&orientation=squarish",
  },
];